//creates plugin object
function createPlugin(element, siteId) {
    const plugin = {};
    plugin["@"] = { PluginId: element.pluginId, Name: element.name || element.plugin };
    if (element.config) {
        if (element.pluginId !== 8) {
            plugin.Configs = { Config: { "@": { LngId: 0 }, Config: element.config } };
        } else {
            const textElementValue = replaceTextElementValue(element.config);
            plugin.Configs = { Config: { "@": { LngId: 1 }, Config: textElementValue } };
        }
            
    }
    plugin.Sites = { Site: [{ "@": { "DefSiteId": siteId } }] };
    return plugin;
}

//check if siteid is attached to plugin, if not, add siteid
function addSiteIdToExistingPlugin(plugin, siteId) {
    const sites = plugin.Sites.Site;
    let containsSiteId = false;
    sites.forEach(site => {
        if (site["@"].DefSiteId === siteId) {
            containsSiteId = true;
        }
    });
    if (!containsSiteId) {
        sites.push({ "@": { "DefSiteId": siteId } });
    }
}

//check if specified plugin exists, return value: plugin obj if found, otherwise null
function pluginExists(plugins, element) {
    for (const p of plugins) {
        if (p["@"].PluginId === element.pluginId && p["@"].Name === element.name) {
            return p;
        }
    }
    return null;
}
//TODO function name is kinda... meh
function getElementsBody(ids) {
    const listMap = new Map();
    const sitesData = require('../../assets/defSites.json');
    //iterate over pages from defSites.json, get the ones with body assembled in creator
    //as Map(key = site.id, value = <App.state[site.listname]>)
    sitesData.forEach(data => {
        ids.push(data.id);
        if (data.listName) {
            listMap.set(data.id, this.state[data.listName]);
        }
    });
    return listMap;
}

function addPluginOrAppendSiteIdToExistingOne(plugins, element, key) {
    const plugin = pluginExists(plugins, element);
    if (plugin) {
        //TODO: config comparison check should be added here
        addSiteIdToExistingPlugin(plugin, key);
    } else {
        plugins.push(createPlugin(element, key));
    }
}

function getPluginsFromElementsBodyForPredefinedPlugin(plugins, element, key) {
    if (element.predefinedPlugin) {
        addPluginOrAppendSiteIdToExistingOne(plugins,element.predefinedPlugin,key);
    }
    for (let i = 2; i < 5; i++) {
        if (element[`predefinedPlugin${i}`]) {
            addPluginOrAppendSiteIdToExistingOne(plugins,element[`predefinedPlugin${i}`],key);
        }
    }
}

//TODO function name is kinda... meh
function getPluginsFromElementsBody(listMap, plugins)
{
    listMap.forEach((value, key) => {
        //iterating over elements in site's body
        value.forEach(element => {
            //add plugins
            if (element.pluginId !== null && element.name !== null) {
                if (element.type === 'newsSection' || element.type === 'promotionalBanner') {
                    const recConfig = JSON.parse(element.config);
                    if (recConfig.Type > 15) {
                        element.pluginId = 2;
                        recConfig.Type = recConfig.Type - 15;
                        recConfig.Value = '-1';
                        delete recConfig["IncludeGroup"];
                        element.config = JSON.stringify(recConfig);
                    }
                }
                addPluginOrAppendSiteIdToExistingOne(plugins, element,key);
            }
            getPluginsFromElementsBodyForPredefinedPlugin(plugins, element, key);
        });
    });
}

function changePluginsInPreviewsAfterGenerate(listMap, plugins) {
    listMap.forEach((value, key) => {
        value.forEach(element => {
            if (element.pluginId !== null && element.name !== null) {
                if (element.type === 'newsSection' && element.pluginId === 2) {
                    const recConfig = JSON.parse(element.config);
                        element.pluginId = 1;
                        recConfig.Type = recConfig.Type + 15;
                        delete recConfig["Value"];
                        element.config = JSON.stringify(recConfig);  
                }
                addPluginOrAppendSiteIdToExistingOne(plugins, element,key);
            }
        });
    });
}

function addPluginForCommonElement(element, ids, plugins)
{
    if (element.pluginId !== null && element.name !== null) {
        const elementPlugin = createPlugin(element, ids[0]);
        if (element.type === 'header') {
            ids.slice(1).filter(defId => defId !== 31)
            .forEach(id => addSiteIdToExistingPlugin(elementPlugin, id));
        } else {
            ids.slice(1).forEach(id => addSiteIdToExistingPlugin(elementPlugin, id));
        }

        //add header plugin to page with error 404
        // if(elementPlugin["@"].PluginId === 5) {
        //     addAdditionalSitesIdToExistingPluginManually(elementPlugin, elementPlugin["@"].PluginId,20);
        // }

        plugins.push(elementPlugin);
    }
}

function getStaticElementsWithPlugins()
{
    const elementsWithPlugins = new Map();
    const defSites = require('../../assets/defSites.json');
    //iterate over defsites, 
    defSites.forEach(elem => {
        //get defSites without listName ie. the ones that are staticElements, not built in creator gui
        if (elem.listName) {
            return;
        }
        try{
            const declaration = require("../../assets/static-elements/"+elem.name.split(".")[0]).default[0];
            //of these ones, get the ones that use a plugin
            if(declaration.plugin == null || declaration.pluginId == null) {
                return;
            }
            const arr = [declaration];
            if (declaration.predefinedPlugin) {
                arr.push(declaration.predefinedPlugin);
            }
            if (declaration.predefinedPlugin2) {
                arr.push(declaration.predefinedPlugin2);
            }
            elementsWithPlugins.set(elem.id, arr);

        } catch(e){ 
            console.log(`${elem.name} doesn't have a corresponding file in staticElements`) 
        }
    });
    //DONE
    return elementsWithPlugins;
}


//TODO this function does now add plugins from staticElements but that module could use some refactoring
//TODO this function doesn't add plugin config json in static elements, add it
function getPlugins() {
    const ids = [];
    const listMap = getElementsBody.call(this,ids);
    
    const plugins = [];
    //iterate over whole map
    getPluginsFromElementsBody(listMap, plugins);

    const elementsWithPlugins = getStaticElementsWithPlugins();
    elementsWithPlugins.forEach((value, key) => {
        value.forEach(val => {
            if (val.pluginId !== null && val.name !== null) {
                addPluginOrAppendSiteIdToExistingOne(plugins,val,key);
            }
        })
    })

    const header = this.state.header[0];
    const footer = this.state.footer[0];
    addPluginForCommonElement(header, ids, plugins);
    addPluginForCommonElement(footer, ids, plugins);
    const pluginsCopy = plugins;
    changePluginsInPreviewsAfterGenerate(listMap, plugins);
    return { "Plugin": pluginsCopy };
}

function replaceTextElementValue(textElementValue) {
    textElementValue = textElementValue.replaceAll('&amp;lt;', '<');
    textElementValue = textElementValue.replaceAll('&lt;', '<');
    textElementValue = textElementValue.replaceAll('&gt;', '>');
    return textElementValue
}
export default getPlugins;